import { sortBy, get } from 'lodash'
import { flow, set } from 'lodash/fp'
import { dateToColumnLabel } from '../chartHelpers'

export const prepareDataForCharts = ({
  sessionCounts = [],
  periodDateGroup,
  convertDateToTimezone,
}) => {
  const { consultationsInPeriod, total } = sessionCounts
    .flatMap(({ date, unix, chartData }) => ({
      date,
      unix,
      // sum of pending and finished consultations
      value: get(chartData, [0, 'value'], 0) + get(chartData, [1, 'value'], 0),
    }))
    .reduce(
      (acc, { date, value, unix }) =>
        flow([
          set(
            ['consultationsInPeriod', unix, 'columnLabel'],
            dateToColumnLabel(periodDateGroup, date, convertDateToTimezone)
          ),
          set(['total'], acc.total + value),
          set(['consultationsInPeriod', unix, 'count'], value),
        ])(acc),
      { total: 0, consultationsInPeriod: {} }
    )
  // Transform `consultationsInPeriod` to array, sorted by `key` (= time in ms)
  // which is 0th item of `[key, value]` pair of `Object.entries`.
  // Sorting is important for Recharts library input
  // because it will draw a bars in order of given array.
  const chartData = sortBy(Object.entries(consultationsInPeriod), 0).map(
    ([, item]) => item
  )

  return { chartData, total }
}
